import { clubTracts, isHuntTract } from './clubBoundaryRole';

export const CLUB_LAND_DELETE_STANDS_BLOCKED =
  'Delete the stands on this tract first, then come back and delete the boundary.';

export const CLUB_LAND_DELETE_TRACT =
  'Delete this club boundary? Fields drawn inside it stay on the map and can be deleted separately. This cannot be undone.';

export const CLUB_LAND_DELETE_LAST_TRACT =
  'The club map will have no property line until you draw one again.';

export const CLUB_LAND_DELETE_FIELD =
  'Delete this field? Planting plans that use it will drop this plot. This cannot be undone.';

export function clubLandNumericId(area) {
  if (!area || area.id == null) return null;
  const idStr = String(area.id);
  if (idStr.startsWith('location-') || idStr.startsWith('clubline-')) return null;
  const raw = idStr.replace(/^boundary-/, '');
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : null;
}

export function clubLandParentedLocationCount(area, locations = []) {
  const id = clubLandNumericId(area);
  if (id == null || !Array.isArray(locations)) return 0;
  return locations.filter((loc) => Number(loc?.hunt_boundary) === id).length;
}

export function clubLandDeletePayload() {
  return { confirm: true };
}

export function clubLandDeletePlan(area, { boundaries = [], locations = [] } = {}) {
  if (clubLandNumericId(area) == null) return null;
  if (clubLandParentedLocationCount(area, locations) > 0) {
    return {
      blocked: true,
      title: 'Delete stands first',
      body: CLUB_LAND_DELETE_STANDS_BLOCKED,
    };
  }
  if (!isHuntTract(area)) {
    return {
      blocked: false,
      title: 'Delete field',
      body: CLUB_LAND_DELETE_FIELD,
    };
  }
  const lastTract = clubTracts(boundaries).length <= 1;
  return {
    blocked: false,
    title: 'Delete club boundary',
    body: lastTract
      ? `${CLUB_LAND_DELETE_TRACT} ${CLUB_LAND_DELETE_LAST_TRACT}`
      : CLUB_LAND_DELETE_TRACT,
  };
}
